import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export function useCampaigns() {
  const [camps, setCamps] = useState([]);
  useEffect(() => { api.get("/campaigns").then((r) => setCamps(r.data)); }, []);
  return camps;
}

export function CampaignSelect({ value, onChange, camps, withAll, testid, className = "w-60" }) {
  return (
    <Select value={value || "shared"} onValueChange={onChange}>
      <SelectTrigger className={className} data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>
        {withAll && <SelectItem value="all">All campaigns</SelectItem>}
        <SelectItem value="shared">Shared library (no campaign)</SelectItem>
        {camps.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
